import React from 'react'
import BannerMain from '../Banner/BannerMain'
import AllChart from '../Chart/AllChart'
import LowerSection from './LowerSection/LowerSection'
import MiddleSection from './MiddleSection/MiddleSection'

const Home = () => {
    return (
        <>
            <BannerMain />
            <AllChart />
            <MiddleSection/>
            <LowerSection/>
        </>
    )
}

export default Home